module.exports = __webpack_public_path__ + "img/logo.dd010216.png";